import { render, staticRenderFns } from "./CarnetAddress.vue?vue&type=template&id=72e5e4b4&scoped=true&"
import script from "./CarnetAddress.vue?vue&type=script&lang=js&"
export * from "./CarnetAddress.vue?vue&type=script&lang=js&"
import style0 from "./CarnetAddress.vue?vue&type=style&index=0&id=72e5e4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5e4b4",
  null
  
)

export default component.exports